import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Tooltip, MeasureIcon } from '@frontend/components';

import ViewerButton from '../components/ViewerButton';
import ViewerButtonTooltip from '../components/ViewerButtonTooltip';
import { measurementTool } from '../data/actions';
import { getIsMeasurementToolActive } from '../data/reducer';

const MeasurementTool = ({
  isEnabled, // passed in as direct prop
}) => {
  const isActive = useSelector(getIsMeasurementToolActive);
  const dispatch = useDispatch();
  const toggleMeasurementTool = useCallback(() => {
    dispatch(measurementTool.toggle());
  }, [dispatch]);
  return isEnabled ? (
    <Tooltip
      placement="bottom"
      label={<ViewerButtonTooltip firstLine="Measure" />}
    >
      <ViewerButton
        isActive={isActive}
        aria-label="Measure"
        onClick={toggleMeasurementTool}
      >
        <MeasureIcon boxSize={3} />
      </ViewerButton>
    </Tooltip>
  ) : null;
};

export default MeasurementTool;
